import { License, ResponseLicense } from '../models/license.model';

export function adaptRequestLicense(response: ResponseLicense): License {
  return {
    isLicenseValid: response.data.is_license_valid,
    remainingTime: response.data.remaining_time_seconds,
    licenseExpirationDate: response.data.license_expiration_date,
  };
}

// export function adaptRequestLicense(response: ResponseLicense): License {
//   return {
//     isLicenseValid: true,
//     remainingTime: 1653123,
//     licenseExpirationDate: '2025-10-04 12:23:41',
//   };
// }
